function moveToAnchor(anchor, offset) {
    let anchorName = anchor.replace('#', '');
    let findTag = document.querySelector('a[name=' + anchorName + ']');
    if (findTag == null) {
        findTag = document.getElementById(anchorName);
    }

    if (findTag != null) {
        let scrollOfset = findTag.getBoundingClientRect().top + window.scrollY - offset;
        window.scrollTo({
            top: scrollOfset,
            behavior: 'smooth'
        });
    }
}

document.addEventListener("DOMContentLoaded", function (event) {
    const offset = 100;

    document.querySelectorAll('a[href^="#"]').forEach(anchor => {
        anchor.addEventListener('click', function (e) {
            e.preventDefault();
            moveToAnchor(this.getAttribute('href'), offset)
        });
    });

    if (window.location.hash) {
        moveToAnchor(window.location.hash, offset);
    }
});
